import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTokenPrice',
})
export class FormatTokenPricePipe implements PipeTransform {
  transform(value: number): string {
    return value.toFixed(3);
  }
}
